import { string } from "prop-types";
import { useCallback } from "react";

import styled from "styled-components";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";
import { useMemberToolbarStore } from "CrossFeatureComponents/MemberToolbar/memberToolbarStore";
import FnrTypography from "FnrTypography";

import FnrContainedIcon from "UI/FnrContainedIcon";

import { ButtonWrapper } from "../../shared";

const DisplayComponent = ({ color }) => {
  return (
    <DisplayComponentWrapper>
      <SFnrContainedIcon color={color} icon="fa-question-circle fas" />
      <FnrTypography italic color={color} type="copy" fontSize="sm">
        Contact Flocknote Support
      </FnrTypography>
    </DisplayComponentWrapper>
  );
};

DisplayComponent.propTypes = { color: string };

const SupportInquiryButton = () => {
  const { setActiveContentKey } = useMemberToolbarStore();
  const {
    flocknoteSupport,
    generalInquiry,
    prayerRequest,
    setFlocknoteSupport,
    setGeneralInquiry,
    setPrayerRequest,
  } = useMemberToobarContext();

  const showSupportInquiry = useCallback(() => {
    setActiveContentKey(contentKeys.form);
    setFlocknoteSupport(true);
    setGeneralInquiry(false);
    setPrayerRequest(false);
  }, [
    setActiveContentKey,
    setFlocknoteSupport,
    setGeneralInquiry,

    setPrayerRequest,
  ]);

  return (
    <SButtonWrapper
      onClick={showSupportInquiry}
      data-cy="MemberToolbar_SupportInquiryButton"
      type="button"
      DisplayComponent={DisplayComponent}
      autoFocus={flocknoteSupport && !generalInquiry && !prayerRequest}
    />
  );
};

const SFnrContainedIcon = styled(FnrContainedIcon)`
  width: 40px;
`;

const SButtonWrapper = styled(ButtonWrapper)`
  margin: -4px 0 4px 0;
  display: flex;
  align-items: center;
  padding-right: 12px;
  max-width: fit-content;
`;

const DisplayComponentWrapper = styled.div`
  display: flex;
  max-width: fit-content;
  align-items: center;
  gap: 12px;
`;

export default SupportInquiryButton;
